export default __webpack_public_path__ + "static/media/KP.0a42efea.ico";